import React, { useState } from "react";
import Loader from "../../components/Loader/Loader";
import CustomInput from "../../components/UI/CustomInput/CustomInput";
import classes from "./ForgotPassword.module.css";

const ForgotPassword = () => {
    const [loading, setLoading] = useState(false);
    const [input, setInput] = useState("");
    const formHandler = async () => {
        setLoading(true);
        await setTimeout(() => {
            setLoading(false);
        }, 1500);
    };
    return (
        <div className={classes.forgotPassword}>
            <div className={classes.forgotPassword__content}>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <form onSubmit={formHandler}>
                            <CustomInput
                                type="email"
                                name="email"
                                placeholder="Введите свой email"
                                onChange={(e: any) => setInput(e.target.value)}
                                value={input}
                            />
                            <CustomInput type="submit" value="Восстановить пароль" />
                        </form>
                    </>
                )}
            </div>
        </div>
    );
};

export default ForgotPassword;
